<template>
  <div v-show="show">
    <div class="header"><img style="width: 150px; " src="../../../static/logo.png" class="logo" alt="" ></div>
    <van-nav-bar title="用户注册" left-text="返回" left-arrow @click-left="topre">
      <template #right/>
    </van-nav-bar>
    <div style="margin: 20px ; ">
      <van-form @submit="save">

        <van-field v-model="name" :rules="[{ required: true, message: '请输入用户名！' }]" left-icon="user-o" type="text" label="姓名" />
        <van-field v-model="phone" :rules="[{ required: true, message: '请输入手机号！' }]" left-icon="phone-o" type="tel" label="手机号" />
        <van-field v-model="idcard" :rules="[{ validator, message: '请输入正确的身份证号！' }]" left-icon="phone-o" type="tel" label="身份证号" />

        <van-field v-model="pas" :rules="[{ required: true, message: '请输入密码！' }]" left-icon="browsing-history-o" type="password" label="密码" />
        <van-field v-model="pass" :rules="[{ required: true, message: '请确认密码！' }]" left-icon="eye-o" type="password" label="确认密码" />

        <van-field v-model="yzm" :rules="[{ required: true, message: '验证码不能为空！' }]" clearable label="验证码" left-icon="comment-o" placeholder="验证码">
          <van-button slot="button" :disabled="codeDisabled" size="small" type="primary" @click="getCode">{{ codeMsg }}</van-button>
        </van-field>

        <!-- <div>

          <van-button style="margin-top: 10px;" type="primary" size="large" @click="save">确定</van-button>
        </div> -->
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
import { Notify } from 'vant';

export default {
  name: 'Register',
  inject: ['reload'],
  data() {
    return {
      value: '',
      name: '',
      phone: '',
      pas: '',
      pass: '',
      tel: '',
      clientname: '',
      show: sessionStorage.getItem('show'),
      sms: '',
      idcard: '',
      yzm: '',
      mobile: '',
      checked: true,
      button: 'xl',
      disabled: false,
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: '获取验证码',
      // 定时器
      timer: null,
      open_id: '',
      client_id: ''
    };
  },
  mounted() {
    sessionStorage.setItem('show', false);
    var that = this;
    // 监听浏览器是否关闭
    window.addEventListener('beforeunload', e => that.browerStatus());
  },
  updated() {
    sessionStorage.setItem('show', false);
  },
  methods: {

    validator(val) {
      const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
      if (!reg.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    browerStatus() {
      // var that = this;
      sessionStorage.setItem('show', false);

      console.log('浏览器刷新||关闭了');
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = '重新发送(' + this.countdown + ')';
              this.codeDisabled = true;
            } else {
              clearInterval(this.timer);
              this.codeMsg = '获取验证码';
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
            if (this.countdown == 59) {
              this.axios
                .post('/customer/staff/send-code', {
                  phone: this.phone,
                  cx_user: 'chunxue'
                })
                .then(res => {
                  if (res.data.success) {
                    Notify({
                      message: '已发送验证码到预留手机号',
                      duration: 1000,
                      background: '#1989fa'
                    });
                    this.mobile = res.data.mobile;
                    this.sms = '';
                  } else {
                    this.sms = res.data.msg;
                    clearInterval(this.timer);
                    this.codeMsg = '获取验证码';
                    this.countdown = 60;
                    this.timer = null;
                    this.codeDisabled = false;
                  }
                });
            }
          }
        }, 1000);
      }
    },
    topre() {
      sessionStorage.setItem('show', true);

      this.$router.go(-1);
      this.reload();
    },
    save() {
      console.log(this.pass !== '' && this.pass !== this.pas);
      if (this.pass !== '' && this.pass !== this.pas) {
        Notify({ type: 'danger', message: '两次密码不一致！' });
      } else {
        this.axios.post('/customer/staff/register ', {
          username: this.name,
          password: this.pas,
          phone: this.phone,
          code: this.yzm,
          cx_user: 'chunxue',
          id_card: this.idcard
        }).then(res => {
          if (res.data.success) {
            Notify({ type: 'success', message: res.data.msg });
            sessionStorage.setItem('show', true);
            this.$router.push('/');
          } else {
            Notify({ type: 'danger', message: res.data.msg });
          }
        });
      }
    }
  }};
</script>

<style scoped>
  .header {
    margin-bottom: 10px;
    padding-top: 1em;
    background: linear-gradient(91deg, #f1eefc, #9dc6ff 70%, #a5bcff); /* （body背景色） */
    text-align: center;
  }
.van-cell >>> .van-field__label {
  width: 65px;
  line-height: 30px;
}
.van-cell{
  margin: 10px 0;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/register.vue